<template>
  <div class="ts-addon-card ts-shadow-3">
    <div
      class="ts-addon-card__header d-flex flex-column flex-sm-row align-items-center mb-03 mb-md-4"
    >
      <div>
        <img
          class="ts-addon-card__img"
          width="36"
          :src="$store.state.baseUrl + image.data.attributes.url"
          :alt="$store.state.baseUrl + image.data.attributes.alternativeText"
        />
      </div>
      <div>
        <h5 class="ts-fs-5 ts-text-gray-5 fw-semibold mb-0">
          {{ title }} <br class="d-none d-sm-block" />
          {{ price }}
          <span class="ts-addon-card__month fw-regular">
            {{ month }}
          </span>
        </h5>
      </div>
    </div>
    <p class="ts-fs-6 ts-text-gray-1a text-center text-sm-start mb-0">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    title: String,
    price: String,
    description: String,
    image: String,
    month: String,
  },
};
</script>

<style lang="scss" scoped>
.ts-addon-card {
  padding: clamp(1rem, 4vw, 1.2rem);
  border-radius: 25px;
  height: 100%;
  &__header {
    gap: 22px;
    @media (max-width: 575px) {
      gap: 5px;
    }
  }
  &__img {
    width: clamp(50px, 7vw, 65px);
  }
  &__month {
    font-size: clamp(10px, 2.5vw, 17px);
  }
  .ts-fs-5 {
    font-size: clamp(18px, 4vw, 18px) !important;
  }
  .ts-fs-6 {
    font-size: clamp(18px, 4vw, 20px);
  }
}
</style>
